import { render, staticRenderFns } from "./error.vue?vue&type=template&id=b587fd3e&scoped=true"
import script from "./error.vue?vue&type=script&lang=ts"
export * from "./error.vue?vue&type=script&lang=ts"
import style0 from "./error.vue?vue&type=style&index=0&id=b587fd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b587fd3e",
  null
  
)

export default component.exports